import { FilterGroupRequest } from 'components/filter/types';
import { TicketFilterRequest } from 'components/filter/types-legacy';

const injectCampaignFilter = (
    campaignId: string | number,
    filters: FilterGroupRequest<TicketFilterRequest>[] = [],
): FilterGroupRequest<TicketFilterRequest>[] => [
    ...filters,
    {
        type: 'and',
        children: {
            campaigns: [
                {
                    value: [campaignId.toString()],
                    operator: '=',
                    type: 'and',
                },
            ],
        },
    },
];

export { injectCampaignFilter };
